import { customElement } from 'aurelia-templating';
import { bindable } from 'aurelia-typed-observable-plugin';

let statusLabelId = 0;

@customElement('mdc-data-table-sort-header')
export class MdcDataTableSortHeader {
  statusLabelId = `sort-status-label-${++statusLabelId}`;

  @bindable
  columnId: string;

  @bindable
  buttonAriaLabel: string;

  @bindable
  sort: 'ascending' | 'descending';
}
